import { useCallback, useState } from "react";

// This hook is use for popup and hover popup to manage the state.
// use only for popup and hover popup. do not use for dialog.
// for dialog, use useDialogState hook.

const usePopupState = (
  initState: boolean = false,
): [boolean, () => void, () => void] => {
  const [isOpen, setIsOpen] = useState(initState);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  return [isOpen, open, close];
};

export default usePopupState;
